import { useTheme } from "@mui/material";
import React from "react";
import { useDispatch } from "react-redux";
import ArrowDown from "../../../../public/assets/icons/ArrowDown";
import LockIcon from "../../../../public/assets/icons/LockIcon";
import { TTheme } from "../../../utils/configs/setupTheme";
import { commonActions } from "../../common/redux/actions";
import { ACCESS_LEVEL } from "../utils/contants";

const SubjectLessonTab = ({
  lesson,
  handleSetHideItems,
  checkIsHideItem,
  handleClickLink,
  location,
  isShowLock,
  handleOpenModalConfirmLogin,
  handleOpenModalConfirmPremium
}) => {
  const dispatch = useDispatch();
  const theme: TTheme = useTheme();
  return lesson?.items?.map((element, index: React.Key | null | undefined) => (
    <div key={index}>
      {lesson?.items?.length > 1 && (
        <button
          type="button"
          onClick={() => {
            handleSetHideItems(index);
          }}
          style={{
            color: "black",
            padding: 0,
            display: "flex",
            justifyContent: "space-between",
            width: "100%"
          }}
        >
          <span className="normal-case font-semibold text-[18px]" style={{ textAlign: "justify" }}>
            {element?.title}
          </span>
          <div
            style={{
              color: theme.palette.primary.gray400,
              transform: !checkIsHideItem(index) ? "rotate(-90deg)" : ""
            }}
          >
            <ArrowDown />
          </div>
        </button>
      )}
      <div className="mt-2 flex flex-col">
        {!checkIsHideItem(index) &&
          element.items?.map((ele, idx: number) => {
            return (
              <button
                type="button"
                key={idx}
                style={{ color: "black" }}
                onClick={() => {
                  dispatch(
                    commonActions.handleDirectUrl(`/${location?.grade}/${location?.subjectsId}/ly-thuyet/${ele.slug}`)
                  );
                  if (ACCESS_LEVEL?.PREMIUM.includes(ele?.access_level) && !isShowLock(ele?.access_level)) {
                    return handleOpenModalConfirmPremium();
                  }
                  if (ele?.access_level === 0 && !isShowLock(ele?.access_level)) {
                    return handleOpenModalConfirmLogin();
                  }
                  return handleClickLink(`/${location?.grade}/${location?.subjectsId}/ly-thuyet/${ele.slug}`);
                }}
                className="flex justify-between w-full hover:bg-greenBland1 px-2 pt-2 rounded-md cursor-pointer items-center"
              >
                <span
                  style={{ marginBottom: 8, textAlign: "start" }}
                  className="normal-case w-[90%] line-clamp-2 text-[15px]"
                >
                  {idx + 1}.&nbsp;{ele?.title}
                </span>
                {!isShowLock(ele?.access_level) && (
                  <span className="mb-2">
                    <LockIcon />
                  </span>
                )}
              </button>
            );
          })}
      </div>
    </div>
  ));
};
export default SubjectLessonTab;
